var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { BaseComponent } from '../../../../../common/components/base.component';
import { HubFacebookFeedsCommand } from '../../../../../commands/hub/event/add.facebook.general.feed.command';
import { HubCalendarStore, HubFacebookLocationFeedsStore, HubFacebookPageFeedsStore, UpdateGeoLocationStore, } from '../../../../../stores/hub.calendar.store';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../../common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from '../../../../../common/components/confirm.modal/confirm.modal.component';
import { HubApiService } from '../../../../../services/hub.api.service';
import { ModalService } from '../../../../../common/services/modal.service';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { clone } from '../../../../../common/extensions';
var LocationFeedListComponent = /** @class */ (function (_super) {
    __extends(LocationFeedListComponent, _super);
    function LocationFeedListComponent(router, hubCalendarStore, hubFacebookLocationFeedsStore, hubApiService, activatedRoute, hubFacebookFeedsStore, updateGeoLocationStore, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.hubCalendarStore = hubCalendarStore;
        _this.hubFacebookLocationFeedsStore = hubFacebookLocationFeedsStore;
        _this.hubApiService = hubApiService;
        _this.activatedRoute = activatedRoute;
        _this.hubFacebookFeedsStore = hubFacebookFeedsStore;
        _this.updateGeoLocationStore = updateGeoLocationStore;
        _this.modalService = modalService;
        _this.isLoadingFeeds = false;
        _this.placeSource = 'google';
        return _this;
    }
    LocationFeedListComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.hubCalendarStore.actionCommand.takeUntil(this.isDestroyed).subscribe(function (command) {
            if (command && command.queryParams && command.queryParams.source) {
                _this.placeSource = command.queryParams.source;
            }
        });
        this.getHubLocations();
        this.hubFacebookLocationFeedsStore.locationCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubLocations) {
            _this.filterByType(hubLocations.hubPages);
        });
    };
    LocationFeedListComponent.prototype.editLocationFeed = function (location) {
        this.updateGeoLocationStore.updateGeoLocationCommand.next(clone(location));
    };
    LocationFeedListComponent.prototype.deleteLocationFeed = function (location) {
        var _this = this;
        var actions = {
            confirm: function (feed) {
                _this.hubApiService
                    .removeLocationFeed(_this.hubName, location.id, location.socialName)
                    .finally(feed.complete)
                    .subscribe(function () {
                    _this.getHubLocations();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this Location?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            confirmCheckboxDescription: 'If geofences are deleted, the entire existing database of places will be deleted, along with the categories and any other promotional labels such as “Editor’s Choice” etc.',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    LocationFeedListComponent.prototype.deleteEventFeed = function (page) {
        var _this = this;
        var actions = {
            confirm: function (feed) {
                _this.hubApiService
                    .removePageFeed(_this.hubName, page.id)
                    .finally(feed.complete)
                    .subscribe(function () {
                    _this.getHubPageFeeds();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this page?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    LocationFeedListComponent.prototype.getHubPageFeeds = function () {
        var _this = this;
        var times = 0;
        var getFeeds = function () {
            return _this.hubApiService
                .getPageFeeds(_this.hubName)
                .catch(function (err) {
                if (times < 3) {
                    getFeeds();
                }
                times++;
                return Observable.throw(err.statusText);
            })
                .subscribe(function (data) {
                _this.hubPages = data;
                var pageCommand = new HubFacebookFeedsCommand(data);
                _this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
            });
        };
        getFeeds();
    };
    LocationFeedListComponent.prototype.getHubLocations = function () {
        var _this = this;
        var times = 0;
        this.isLoadingFeeds = true;
        var getFeeds = function () {
            return _this.hubApiService
                .getLocationFeeds(_this.hubName)
                .catch(function (err) {
                if (times < 3) {
                    getFeeds();
                }
                times++;
                return Observable.throw(err.statusText);
            })
                .subscribe(function (data) {
                _this.isLoadingFeeds = false;
                _this.hubLocations = data;
                _this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(data));
                _this.filterByType(data);
            });
        };
        getFeeds();
    };
    LocationFeedListComponent.prototype.filterByType = function (locations) {
        var _this = this;
        setTimeout(function () {
            if (locations && locations.length) {
                if (_this.type === 'event') {
                    _this.hubLocations = locations.filter(function (x) { return x.socialName === 'eventful'; });
                }
                else if (_this.type === 'place') {
                    _this.hubLocations = locations.filter(function (x) { return x.socialName === _this.placeSource; });
                }
                else {
                    _this.hubLocations = locations;
                }
            }
        });
    };
    LocationFeedListComponent.prototype.copyToClip = function (content) {
        var aux = document.createElement('input');
        aux.setAttribute('value', content);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);
    };
    return LocationFeedListComponent;
}(BaseComponent));
export { LocationFeedListComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/location.feed.list/location.feed.list.component.ts.pre-build-optimizer.js